import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {BaseComponent} from '../../base/base.component';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from "../../service/user.service";
import {Notification} from "../../model/user/notification";
import {AuthType, User} from "../../../generated/graphql";

declare var $: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit {

    user: User;

    constructor(public router: Router,
                public loading: NgxSpinnerService,
                public translate: TranslateService,
                public userService: UserService
    ) {
        super(router, loading, translate);
    }

    ngOnInit(): void {

        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
            }, error: err => super.onError(err)
        });
    }

    actionNavToggle(): void {
        $('body').toggleClass('nav-open');
        $('.hamburger').toggleClass('open');
    }

    setLanguage(l: string) {
        this.switchLanguage(l);
        this.userService.updateLanguage(l);
    }

    actionLogout() {
        // Encerra a sessão local (token em sessionStorage + demais chaves em localStorage)...
        localStorage.clear();
        sessionStorage.clear();
        // ...e encerra a sessão também no Azure AD (logout v2.0 montado a partir do tenant).
        // ATENÇÃO: o post_logout_redirect_uri abaixo ({origin}/logout) precisa estar registrado
        // como "Logout URL" no App Registration do Azure de CADA ambiente (dev/prod), senão a
        // Microsoft recusa o redirect de volta.
        const url = `https://login.microsoftonline.com/${environment.tenant_id}/oauth2/v2.0/logout`
            + `?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + '/logout')}`;
        window.location.href = url;
    }
}
